import { cn } from "@/lib/utils";
import { IconBox } from "components/core/IconBox";
import { Text } from "components/core/Text";
import { ComponentProps, useMemo } from "react";
import { getDday } from "utils/dday";

import { ContentCard } from "./ContentCard";
import { ContentCardScaffold } from "./scaffolds/ContentCardScaffold";

export const OriginalUpcomingCard = ({
    device,
    content,
    ...props
}: Omit<ComponentProps<typeof ContentCard>, "type">) => {
    const dday = useMemo(() => {
        const _dday = getDday(content.updatetime);
        return _dday >= 0 ? `D-${_dday === 0 ? "Day" : _dday}` : "";
    }, [content.updatetime]);

    return (
        <ContentCardScaffold
            className={cn(
                "relative aspect-[1.067] cursor-default items-center justify-center rounded-xl bg-black/70 p-4 backdrop-blur-[15px]"
            )}
            {...props}
        >
            <div className="absolute left-5 top-5 z-[1] flex h-12 w-12 items-center justify-center rounded-[50px] bg-grey-900">
                <IconBox size="xl" name="Lock" color="white" />
            </div>
            <div className="flex max-w-[182px] flex-col items-center justify-center">
                <Text className="mb-2" variant="h1" color="common.white.main">
                    {dday}
                </Text>
                <ContentCardScaffold.Title
                    className="mb-1 text-center"
                    color="common.white.main"
                >
                    {content.title}
                </ContentCardScaffold.Title>
                <Text variant="body4" color="text.secondaryWhite">
                    by. {content.authorname}
                </Text>
            </div>
        </ContentCardScaffold>
    );
};
